import { render, staticRenderFns } from "./DoodlePad.vue?vue&type=template&id=01787ae5&scoped=true"
import script from "./DoodlePad.vue?vue&type=script&lang=js"
export * from "./DoodlePad.vue?vue&type=script&lang=js"
import style0 from "./DoodlePad.vue?vue&type=style&index=0&id=01787ae5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01787ae5",
  null
  
)

export default component.exports